import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./en-US";
import zhCN from "./zh-CN";
import jp from './ja-JP'

export const resourceType = ["en", "zhCN", "jp"];
export const resources = {
  en: {
    translation: en,
  },
  zhCN: {
    translation: zhCN,
  },
  jp: {
    translation: jp,
  }
};

const globalConfigStore = JSON.parse(
  window.localStorage.getItem("global-config-store")
);
i18n.use(initReactI18next).init({
  resources,
  lng: globalConfigStore?.state?.language || "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
